<template>
  <component :is="currentItemComponent" :index="menu.path" :key="menu.path">
    <template slot="title" v-if="hasChildren">
      <i :class="menu['meta'].icon" v-if="menu['meta'].icon"></i>
      <span slot="title">{{ menu["meta"].name }}</span>
    </template>
    <template v-else>
      <!-- 有提示文案 -->
      <el-tooltip
        class="box-item"
        effect="dark"
        :content="menu['meta'].menuDesc"
        placement="right-start"
        v-if="menu['meta'].menuDesc"
      >
        <div @click="handleClickMenu(menu)">
          <i :class="menu['meta'].icon" v-if="menu['meta'].icon"></i>
          <span slot="title">{{ menu["meta"].name }}</span>
        </div>
      </el-tooltip>
      <!-- 无提示文案 -->
      <div v-else @click="handleClickMenu(menu)">
        <i :class="menu['meta'].icon" v-if="menu['meta'].icon"></i>
        <span slot="title">{{ menu["meta"].name }}</span>
      </div>
    </template>
    <!-- 这里用了递归生成菜单项 -->
    <menu-item
      :menu="child"
      :key="child.name"
      v-for="child in menu.children"
      v-if="hasChildren && child['meta'] && child['meta'].menu"
    />
  </component>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import store from "store2";
import { goNewSys } from "@/util/index";
export default {
  name: "menu-item",
  props: {
    menu: Object,
  },
  data() {
    return {
      hasChildren: false,
    };
  },
  computed: {
    ...mapState({
      App: (state) => state.app.data,
    }),
    currentItemComponent() {
      const hasChildren = this.getChildren();

      return hasChildren ? "el-submenu" : "el-menu-item";
    },
    adminInfo() {
      return store.get("user") || {};
    },
  },
  methods: {
    handleClickMenu(subItem) {
      // 一、判断当前跳转是否为统计中心
      const isCountCenter = subItem.path.includes("/count_center");
      // 二、获取当前路由的appid 判断是否为国内appid
      const appid = this.$route.query.appId || "";
      const appInfo = this.App.find((el) => el.id == appid) || {};
      if (subItem.meta.isForcedRedirectV2) {
        // 如果有强制需要跳转v2就直接跳
        goNewSys({
          path: subItem.path_v2 || subItem.path,
          appid: appid,
        });
      } else if (
        isCountCenter &&
        subItem.meta.is_v2_link &&
        this.adminInfo.redirect_to_zt == 1 &&
        appInfo.is_overseas == 0
      ) {
        // 三、统计中心跳转v2的要求 1、必须是统计中心的路由 2、必须在路由中配置is_v2_link 3、用户信息必须包含redirect_v2为 1，4、必须是国内app 5、这里为什么要多一个path_v2 因为还有一部分的路由需要v1使用
        goNewSys({
          path: subItem.path_v2 || subItem.path,
          appid: appid,
        });
      } else if (
        !isCountCenter &&
        subItem.meta.is_v2_link &&
        this.adminInfo.redirect_to_zt == 1
      ) {
        // 四、如果非统计中心 1、配置了is_v2_link 并且用户信息包含redirect_v2为1即可跳转
        goNewSys({ path: subItem.path_v2 || subItem.path });
      } else {
        // 五、不满足以上条件还是保留v1逻辑菜单跳转
        this.$router.push(subItem.path);
      }
    },
    getChildren() {
      const children = this.menu["children"] || [];
      const _children = children.filter((v) => v.meta && v.meta.menu);
      const is = !!_children.length;

      this.hasChildren = is;

      return is;
    },
  },
};
</script>

<style lang="less" scoped></style>
